import { useIntl } from "react-intl";
import { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Button, TableView, Toolbar, ToggleSwitch } from "@gpstrackit/react-controls";
import { Grid, Collapse } from "@mui/material";

//Styles
import './index.scss'

//Actions
import { editAlertTypeSupportedOpenModal } from 'Redux/actions';

const AlertTypesSupported = (props) => {
    const { id, indent = 0, loading, setChanges, deviceModel, dmAlertTypes } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [expanded, setExpanded] = useState([]);
    const [currentSearch, setCurrentSearch] = useState("");
    const [expandAll, setExpandedAll] = useState(false);
    const [supportedEvents, setSupportedEvents] = useState([]);

    const { result } = useSelector(state => state.editAlertTypeSupportedRedux);

    const expand = useCallback((nodeId) => {
        let newExpanded = [...expanded];
        if (expanded.includes(nodeId)) {
            newExpanded = expanded.filter(e => e != nodeId);
        } else newExpanded.push(nodeId);
        setExpanded(newExpanded);
    });

    const compareName = (a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    const handlerExpandAll = (value) => {
        if (value) setExpanded([12])
        else setExpanded([])
        setExpandedAll(value)
    }

    useEffect(() => {
        if (dmAlertTypes && dmAlertTypes.length) {
            let events = dmAlertTypes.map((item) => (item?.alertType))
            let sortedName = events.sort(compareName);
            setSupportedEvents(sortedName)
        }
    }, [dmAlertTypes])

    useEffect(() => {
        if (result && !result?.error) {
            setExpanded([]);
            setExpandedAll(false)
            if(result?.deviceModelAlertTypes && !result.deviceModelAlertTypes.length){
                setSupportedEvents([])
            }
        }
    }, [result])

    return (
        <TableView
            name="features-list-level"
            onSearch={(search) => setCurrentSearch(search)}
            data={currentSearch ? supportedEvents : id ? supportedEvents?.filter((item) => item?.parentId === id) : supportedEvents?.filter((item) => !item?.parentId) || []}
            loading={!id && loading}
            viewType="list"
            messages={messages}
            height={id && '100%'}
            topSpaceSize={!id ? 350 : 0}
            inputSearch={!id ? true : false}
            itemSelector={false}
            renderRow={(feature) => {
                let validateModule = supportedEvents?.some((item) => item?.parentId === feature?.id)
                return (
                    <div style={{ minWidth: 650 }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            className="row-features"
                        >
                            <Grid item xs={6}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ marginLeft: indent, paddingTop: 7, paddingBottom: 7, paddingLeft: 15 }}
                                    wrap="nowrap"
                                >
                                    <Grid item>
                                        {
                                            (!id && validateModule) && !currentSearch ?
                                                <Button
                                                    type="icon"
                                                    icon={expanded.includes(feature.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
                                                    placement="bottom"
                                                    className="btn-xs"
                                                    fontSize="inherit"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        let currentId = feature.id
                                                        expand(currentId)
                                                    }}
                                                /> :
                                                <div style={{ width: 24, height: 24 }}></div>
                                        }
                                    </Grid>
                                    <Grid item xs>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="flex-start"
                                            className="context-menu-container"
                                            wrap="nowrap"
                                        >
                                            <Grid item zeroMinWidth>
                                                <span>{`${feature?.name}`}</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            !currentSearch &&
                            <Collapse in={expanded.includes(feature.id)} timeout="auto" unmountOnExit>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ padding: '0px 0px 0px 0px' }}
                                >
                                    <AlertTypesSupported
                                        id={feature.id}
                                        indent={indent + 30}
                                        loading={loading}
                                        alertTypes={supportedEvents}
                                        setChanges={setChanges}
                                        dmAlertTypes={dmAlertTypes}
                                    />
                                </Grid>
                            </Collapse>
                        }
                    </div>
                )
            }}
            pagination={false}
            toolbarContainerClassName='table-alert-types-toolbar'
        >
            {
                !id && (
                    <Toolbar>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: -4, marginLeft: 20 }}>
                            <Button
                                className="btn-dark-blue"
                                onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(editAlertTypeSupportedOpenModal(true, deviceModel, dmAlertTypes))
                                }}
                            >
                                {messages['edit']}
                            </Button>
                            <ToggleSwitch
                                id="toogle-expand-all"
                                large
                                blueToggle
                                optionLabels={[messages['common_contract'], messages['common_expand']]}
                                checked={expandAll}
                                onChange={handlerExpandAll}
                            />
                        </div>
                    </Toolbar>
                )
            }
        </TableView>
    )
}

export default AlertTypesSupported;